// extracted by mini-css-extract-plugin
export default {"HeroWrapper":"GamersEliteHero_HeroWrapper__TpV0B","purple":"GamersEliteHero_purple__33SNw","info":"GamersEliteHero_info__91WCL"};